import { CloseOutlined } from '@ant-design/icons';
import { Dayjs } from 'dayjs';
import { Popup } from 'react-map-gl';
import React from 'react';
import styles from './popup.less';

export interface WaterTempPopupInfo {
  lat: number;
  lng: number;
  waterTemp: number;
}

interface WaterTempPopupProps {
  onClose: () => void;
  waterTempPopupInfo: WaterTempPopupInfo;
  waterTempWaterbodyName: string;
  waterTempDisplayedDate: Dayjs;
}

export const WaterTempPopup = React.memo((props: WaterTempPopupProps) => {
  const { onClose, waterTempPopupInfo, waterTempWaterbodyName, waterTempDisplayedDate } = props;
  return (
    <>
      {waterTempPopupInfo && (
        <Popup
          longitude={waterTempPopupInfo.lng}
          latitude={waterTempPopupInfo.lat}
          onClose={onClose}
          key={`${waterTempPopupInfo.lng}-${waterTempPopupInfo.lat}`} // for some reason i could only render 1 popup at a time without this
          className={styles.popup}
          closeButton={false}
        >
          <div className={styles.content}>
            <header className={styles.header}>
              <span>{waterTempWaterbodyName}</span>
              <span className={styles.close} onClick={onClose}>
                <span className={styles.closeIcon}>
                  <CloseOutlined />
                </span>
              </span>
            </header>
            <div className={styles.body}>
              <strong>Water Temp at this point</strong>
              <br />
              <span>
                {waterTempPopupInfo.waterTemp} as of {waterTempDisplayedDate?.format('M/DD/YY')}
              </span>
            </div>
          </div>
        </Popup>
      )}
    </>
  );
});
